module.exports = __webpack_public_path__ + "img/card_chilesafety_background.9165c307.png";